import { z } from 'zod'

// Client validation schema
export const clientSchema = z.object({
  firstName: z.string().min(1, 'Le prénom est obligatoire'),
  lastName: z.string().min(1, 'Le nom est obligatoire'),
  email: z.string().email('Email invalide'),
  phone: z.string().min(9, 'Numéro de téléphone invalide'),
})

// Address validation schema
export const addressSchema = z.object({
  street: z.string().min(1, 'La rue est obligatoire'),
  number: z.string().min(1, 'Le numéro est obligatoire'),
  box: z.string().optional(),
  postalCode: z.string().min(4, 'Code postal invalide'),
  city: z.string().min(1, 'La ville est obligatoire'),
  floor: z.string().optional(),
})

// Project creation - Step 1 (ProjectType comes from backend)
export const projectStep1Schema = z.object({
  type: z.string().min(1, 'Type de projet requis'),
  client: clientSchema,
  siteAddress: addressSchema,
  billingAddressSameAsSite: z.boolean().optional(),
  billingAddress: addressSchema.optional(),
  deliveryDate: z.string().min(1, 'La date de livraison est obligatoire'),
  quoteDeadline: z.string().optional(),
})

// Project creation - Step 2
export const projectStep2Schema = z.object({
  constructionType: z.enum(['neuf', 'renovation']),
  defaultFinishes: z.object({
    doors: z.object({
      material: z.string().min(1, 'Le matériau est obligatoire'),
      color: z.string().min(1, 'La couleur est obligatoire'),
      finish: z.string().min(1, 'La finition est obligatoire'),
    }),
    carcasses: z.object({
      material: z.string().min(1, 'Le matériau est obligatoire'),
      color: z.string().min(1, 'La couleur est obligatoire'),
    }),
    worktops: z.object({
      material: z.string().min(1, 'Le matériau est obligatoire'),
      thickness: z.string().min(1, "L'épaisseur est obligatoire"),
      color: z.string().min(1, 'La couleur est obligatoire'),
    }),
  }),
})

// Element validation schema
export const elementSchema = z.object({
  type: z.enum([
    'meuble_bas',
    'meuble_haut',
    'colonne',
    'joue',
    'resserrage',
    'electromenager',
    'plan_travail',
    'evier',
    'robinetterie',
    'autre',
  ]),
  name: z.string().min(1, 'Le nom est obligatoire'),
  dimensions: z
    .object({
      length: z.number().positive('La longueur doit être positive'),
      depth: z.number().positive('La profondeur doit être positive'),
      height: z.number().positive('La hauteur doit être positive'),
    })
    .optional(),
  finishes: z
    .object({
      material: z.string().optional(),
      color: z.string().optional(),
      finish: z.string().optional(),
      thickness: z.string().optional(),
    })
    .optional(),
  price: z.number().positive('Le prix doit être positif'),
  notes: z.string().optional(),
})

// Login validation schema (traditional - deprecated)
export const loginSchema = z.object({
  email: z.string().email('Email invalide'),
  password: z.string().min(6, 'Le mot de passe doit contenir au moins 6 caractères'),
  rememberMe: z.boolean().optional(),
})

// Magic link validation schema
export const magicLinkSchema = z.object({
  email: z.string().email('Email invalide'),
})

// Send quote validation schema
export const sendQuoteSchema = z.object({
  recipientEmail: z.string().email('Email invalide'),
  subject: z.string().min(1, "L'objet est obligatoire"),
  message: z.string().min(1, 'Le message est obligatoire'),
  ccEmails: z.array(z.string().email()).optional(),
})
